import React, { forwardRef } from 'react';
import { DocumentUploadCategory } from 'types/Documents';
import Modal, { ModalRef } from 'components/Modal/Modal';
import blueprintImg from './assets/blueprint.png';
import aerialImg from './assets/aerialView.png';
import entranceImg from './assets/entry.jpeg';
import exitImg from './assets/exit.jpeg';
import ShieldCheckIcon from 'assets/icons/shieldCheck.svg?react';
import styles from './NewOwnerOnboarding.module.css';

export const BlueprintInfo = forwardRef<ModalRef>((_, ref) => (
    <Modal ref={ref} title="Help Us Understand Your Parking Layout">
        <div className={styles.infoModalContainer}>
            <p className={styles.infoModalDescription}>
                Upload a parking lot map, blueprint, or site plan that clearly shows parking spaces, driving lanes,
                entrances, exits, and any reserved areas. Clear documentation helps us configure your parking lot
                correctly.
            </p>
            <p className={styles.examplesLabel}>Examples</p>
            <div className={styles.examples}>
                <img src={aerialImg} alt="Aerial view example" className={styles.exampleImage} />
                <img src={blueprintImg} alt="Blueprint example" className={styles.exampleImage} />
            </div>
        </div>
    </Modal>
));

export const EntryExitInfo = forwardRef<ModalRef>((_, ref) => (
    <Modal ref={ref} title="Help Us Identify Your Parking Access Points">
        <div className={styles.infoModalContainer}>
            <p className={styles.infoModalDescription}>
                Take photos similar to the examples below, showing both the parking entrance and exit. Include any
                gates, ticket machines, signs, and driving lanes whenever possible. Clear photos help ensure an
                efficient onboarding process.
            </p>
            <p className={styles.examplesLabel}>Examples</p>
            <div className={styles.examples}>
                <img src={entranceImg} alt="Parking entrance example" className={styles.exampleImage} />
                <img src={exitImg} alt="Parking exit example" className={styles.exampleImage} />
            </div>
        </div>
    </Modal>
));

export function CategoryBadge({ category }: { category: DocumentUploadCategory }): JSX.Element {
    const isRequired = category.is_required;
    return (
        <span className={`${styles.badge} ${!isRequired ? styles.badgeOptional : ''}`}>
            {isRequired ? 'Required' : 'Optional'}
        </span>
    );
}

export function DoneBadge(): JSX.Element {
    return <span className={styles.doneBadge}>✓ Done</span>;
}

export function SecurityInfo(): JSX.Element {
    return (
        <div className={styles.securityInfo}>
            <ShieldCheckIcon />
            <p>
                Your documents are securely encrypted and handled with care. We only use them to verify your property,
                process payments, and support your account.
            </p>
        </div>
    );
}
